import { Component } from '@angular/core';
import { PktrAppMenuService } from '@prospektr/pktr-app-menu';

interface MenuItems {
  linkText: string;
  link: string;
  openInNewTab: boolean;
  icon: string;
}
@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css'],
})
export class MainMenuComponent {
  isSidebarOpened: boolean = false;
  curActiveLink: string = '';

  constructor(public _pktrAppMenuService: PktrAppMenuService) { }

}
